import * as React from 'react';

import atob from 'atob';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import type { LegacyContextType } from 'types/legacy-context-types';

import connectToRouter from 'js/lib/connectToRouter';
import redirect from 'js/lib/coursera.redirect';

import PageHeader from 'bundles/page-header/components/PageHeader';
import type { ZoomState } from 'bundles/third-party-auth/types/ZoomState';
import { link } from 'bundles/third-party-auth/utils/ZoomAuthAPIUtils';

type PropsFromRouter = {
  stateFromZoom?: ZoomState;
  code?: string;
  isDev: boolean;
};

type Props = PropsFromRouter;

export class ZoomAccountLinkingRedirect extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof ZoomAccountLinkingRedirect.contextTypes>;

  static defaultProps = {
    isDev: false,
  };

  componentDidMount() {
    const { stateFromZoom, code, isDev } = this.props;

    if (code) {
      link(code, isDev).then(() => {
        let redirectUrl;

        if (stateFromZoom) {
          const { slug, contextId } = stateFromZoom;
          redirectUrl = `/teach/${slug}/${contextId}/learners/live_events?showEventDetailsModal=true`;

          if (isDev) {
            redirectUrl += `&isDev=true`;
          }
        } else {
          redirectUrl = `/account-settings`;

          if (isDev) {
            redirectUrl += `?isDev=true`;
          }
        }

        redirect.setLocation(redirectUrl);
      });
    }
  }

  render() {
    return (
      <div className="rc-ZoomAccountLinkingRedirect">
        <PageHeader />
      </div>
    );
  }
}

export default compose<PropsFromRouter, {}>(
  connectToRouter((router) => {
    const isDev = router.location.pathname === '/zoom-account-linking-dev';
    const stateFromZoom = router.location.query?.state && JSON.parse(atob(router.location.query?.state));
    const code = router.location.query?.code;
    return {
      code,
      stateFromZoom,
      isDev,
    };
  })
)(ZoomAccountLinkingRedirect);
